module.exports = __webpack_public_path__ + "img/gold-1242.ec047e49.png";